export default {
  get (cook) {
    return localStorage.getItem(cook)
  },
  set (cook, data) {
    return localStorage.setItem(cook, data)
  },
  remove (data) {
    return localStorage.removeItem(data)
  },
  getJson (cook) {
    return JSON.parse(localStorage.getItem(cook))
  },
  setJson (cook, data) {
    return localStorage.setItem(cook, JSON.stringify(data))
  }
}
